import React from "react";

const educationContent = [
	{
		year: "2018 - 2021",
		degree: "COMPUTER SCIENCE DEGREE",
		institute: "NDEJJE UNIVERSITY",
		details: `  I completed a Bachelor's Degree in Computer Science which helped me to acquire knowledge of different software development methodologies, Relational Database Management, software programming among others`,
	},
	// {
	//   year: "2016 - 2017",
	//   degree: "UACE CERTIFICATE",
	//   institute: "NDEJJE SSS",
	//   details: `Lorem incididunt dolor sit amet, consectetur eiusmod dunt doldunt dol
	//       elit, tempor incididunt`,
	// },
	// {
	//   year: "2009",
	//   degree: "BACHELOR DEGREE ",
	//   institute: "TUNIS HIGH SCHOOL",
	//   details: `Lorem ipsum dolor sit amet, tempor incididunt ut laboreconsectetur
	//       elit, sed do eiusmod tempor duntt`,
	// },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
